import Profile from '../ui/Profile';
import { connect } from 'react-redux';
import { updateAllVaccinationStatus, hostProfileSubmit, skipSubmit, goBack } from '../../actions';

const mapStateToProps = (state, props) =>
  ({
    page: state.page,
    intl: props.intl,
    user: state.user,
    content: state.content,
    profileElements: state.profileElements,
    localProfileElements: state.localProfileElements,
    activeProfileElements: state.activeProfileElements,
    vaccinationMandatory: state.vaccinationMandatory,
    residents: state.residents,
    requiredFields: state.requiredFields
  });

const mapDispatchToProps = dispatch =>
  ({
    onHostProfileSubmit(payload) {
      dispatch(
        hostProfileSubmit(payload)
      );
    },
    onSkipSubmit(payload) {
      dispatch(
        skipSubmit(payload)
      );
    },
    onGoBack(payload) {
      dispatch(
        goBack(payload)
      );
    },
    onUpdateAllVaccinationsStatus(payload) {
      dispatch(
        updateAllVaccinationStatus(payload)
      );
    }
  });

const Container = connect(mapStateToProps, mapDispatchToProps)(Profile);

export default Container;
